import React from "react";
import {
  Grid2,
  SxProps,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { InfoChips } from "@components/InfoChips/InfoChips";
import { HorizontalBarChart } from "@components/Chart/HorizontalBarChart";
import { HorizontalBarChartItem } from "@components/Chart/HorizontalBarChart/types";
import { InfoChip } from "@components/InfoChips/types";

type Props = {
  data?: HorizontalBarChartItem[];
  infoTags?: InfoChip[];
  displayHorizontalBarChart?: boolean;
  containerSx?: SxProps;
};

export const PerformanceAndTags = ({
  data,
  infoTags,
  displayHorizontalBarChart,
  containerSx,
}: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isLessSm = useMediaQuery(theme.breakpoints.down("sm"));

  if (!data && !infoTags) return null;

  return (
    <Grid2
      container
      pt={7}
      pb={7}
      spacing={isLessSm ? 0 : 11}
      sx={{ borderBottom: 1, borderColor: "border.secondary", ...containerSx }}
    >
      {displayHorizontalBarChart && Boolean(data?.length) && (
        <Grid2
          pb={isLessSm ? 7 : 0}
          sx={{
            borderBottom: isLessSm ? 1 : 0,
            borderColor: "border.secondary",
          }}
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <Typography variant="body1" mb={4}>
            {t("performanceTags.title")}
          </Typography>
          <HorizontalBarChart
            data={data ?? []}
            textColor="gainLoss"
            alignPercentage="left"
          />
        </Grid2>
      )}
      <Grid2
        pt={isLessSm ? 7 : 0}
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <Typography variant="body1" mb={4}>
          {t("performanceTags.tags")}
        </Typography>
        {infoTags?.length && <InfoChips options={infoTags} />}
      </Grid2>
    </Grid2>
  );
};
